import { format } from 'date-fns';

export const formatDate = (date: Date, dateFormat: string = 'dd.MM.yy') =>
  format(new Date(date), dateFormat);
